import * as THREE from "three";
import Experience from "./Experience";
import coffeeVertexShader from "/shaders/coffeeSteam/coffeeVertexShader.glsl";
import coffeeFragmentShader from "/shaders/coffeeSteam/coffeeFragmentShader.glsl";
import CustomEase from "gsap/CustomEase";

import gsap from "gsap";
export default class World {
  constructor() {
    this.experience = new Experience();

    gsap.registerPlugin(CustomEase);
    this.debug = this.experience.debug;
    this.size = this.experience.size;
    this.time = this.experience.time;

    this.scene = this.experience.scene;
    this.sizes = this.experience.size;
    this.resources = this.experience.resources;
    this.camera = this.experience.camera.instance;
    this.controls = this.experience.camera.controls;
    this.html = this.experience.html;

    this.bloomModels = [];

    this.debugSettings = {
      objectActive: true,
      myProperty: () => {
        if (this.scene.background) {
          this.scene.background = false;
        } else {
          this.scene.background = this.environmentTexture;
        }
      },

      stopObjectRotation: () => {
        if (this.debugSettings.objectActive) {
          this.debugSettings.objectActive = false;
        } else {
          this.debugSettings.objectActive = true;
        }
      },
    };

    this.infoContainerOpen = false;
    //! HTML MANIPULATION
    //? butotns
    this.buttonContainer = this.html.buttonContainer;

    //? info con
    this.infoContainer = this.html.infoContainer;
    this.title = this.html.title;
    this.closeInfoButton = this.html.closeInfoButton;
    this.activitiesPDF = this.html.activitiesPDF;
    this.presentationPDF = this.html.presentationPDF;
    this.travailDeBachelorPDF = this.html.travailDeBachelorPDF;

    //? RAYCASTER
    this.rayCaster = new THREE.Raycaster();
    this.pointer = new THREE.Vector2();

    this.intersectObjects = [];
    this.currentIntersects = null;
    this.clicked = false;

    document.addEventListener("click", (e) => {
      this.clicked = true;
    });

    window.addEventListener("mousemove", (event) => {
      this.pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
      this.pointer.y = -(event.clientY / window.innerHeight) * 2 + 1;
    });

    this.setUpScene();
  }

  setUpScene() {
    this.resources.on("resourcesReady", () => {
      this.firstTexture = this.resources.items.firstTexture;
      this.firstTexture.flipY = false;
      this.firstTexture.colorSpace = THREE.SRGBColorSpace;

      this.secondTexture = this.resources.items.secondTexture;
      this.secondTexture.flipY = false;
      this.secondTexture.colorSpace = THREE.SRGBColorSpace;

      this.thirdTexture = this.resources.items.thirdTexture;
      this.thirdTexture.flipY = false;
      this.thirdTexture.colorSpace = THREE.SRGBColorSpace;

      this.floorTexture = this.resources.items.floorTexture;
      this.floorTexture.flipY = false;
      this.floorTexture.colorSpace = THREE.SRGBColorSpace;

      this.realTextures = this.resources.items.realTextures;
      this.realTextures.flipY = false;
      this.realTextures.colorSpace = THREE.SRGBColorSpace;

      this.kioskTexture = this.resources.items.kioskTexture;
      this.kioskTexture.flipY = false;
      this.kioskTexture.colorSpace = THREE.SRGBColorSpace;

      this.bannerTexture = this.resources.items.bannerTexture;
      this.bannerTexture.flipY = false;
      this.bannerTexture.colorSpace = THREE.SRGBColorSpace;

      this.partnersTexture = this.resources.items.partnersTexture;
      this.partnersTexture.flipY = false;
      this.partnersTexture.colorSpace = THREE.SRGBColorSpace;

      this.documentsTexture = this.resources.items.documentsTexture;
      this.documentsTexture.flipY = false;
      this.documentsTexture.colorSpace = THREE.SRGBColorSpace;

      //?perlin texture to animate firstSmoke
      this.perlinTexture = this.resources.items.perlinTexture;
      this.perlinTexture.wrapS = THREE.RepeatWrapping;
      this.perlinTexture.wrapT = THREE.RepeatWrapping;

      //? firstSmoke geometry
      this.smokeGeometry = new THREE.PlaneGeometry(0.25, 0.5, 16, 64);
      this.smokeGeometry.translate(0, 0.5, 0);
      // this.smokeGeometry.scale(0.08 / 1.5, 0.3 / 1.5, 0.08 / 1.5);

      //? firstSmoke

      this.smokeMaterial = new THREE.ShaderMaterial({
        // wireframe: true,
        uniforms: {
          uTime: new THREE.Uniform(0),
          uPerlinTexture: { value: this.perlinTexture },
        },
        vertexShader: coffeeVertexShader,
        fragmentShader: coffeeFragmentShader,
        side: THREE.DoubleSide,
        transparent: true,
      });

      this.firstSmoke = new THREE.Mesh(this.smokeGeometry, this.smokeMaterial);
      this.firstSmoke.rotation.y = 1.5;
      this.firstSmoke.position.set(-0.57, 0.41, 0.09);
      this.firstSmoke.scale.set(0, 0, 0);
      this.scene.add(this.firstSmoke);

      this.secondSmoke = new THREE.Mesh(this.smokeGeometry, this.smokeMaterial);
      this.secondSmoke.rotation.y = 1.5;
      this.secondSmoke.position.set(-0.57, 0.41, 0.5);
      this.secondSmoke.scale.set(0, 0, 0);
      this.scene.add(this.secondSmoke);

      this.scene.fog = new THREE.Fog(0xffd700, 5, 45);

      this.bottles = [];

      this.piaggioModel = this.resources.items.piaggioModel;

      this.bottleOne = new THREE.Group();
      this.bottleTwo = new THREE.Group();
      this.bottleThree = new THREE.Group();
      this.bottleFour = new THREE.Group();
      const targetsToMove = [];

      //? models to animate

      this.plloqa = null;
      this.plateFirst = null;
      this.plateSecond = null;
      this.foodFirst = null;
      this.foodSecond = null;
      this.foodThird = null;

      //? kiosk
      this.cashRegister = null;
      this.ketchupFirst = null;
      this.ketchupSecond = null;
      this.hotPlateOne = null;
      this.hotPlateTwo = null;
      this.kioskPlloqa = null;

      this.piaggioModel.scene.traverse((e) => {
        if (e.isMesh) {
          if (e.name.endsWith("_f")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.firstTexture,
            });
          }

          if (e.name.endsWith("_s")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.secondTexture,
            });
          }

          if (e.name.endsWith("_th")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.thirdTexture,
            });
          }

          if (e.name.startsWith("floor")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.floorTexture,
            });
          }

          if (e.name.startsWith("real")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.realTextures,
            });
          }

          if (e.name.endsWith("kiosk")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.kioskTexture,
            });
          }

          if (e.name.startsWith("real_logo")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.realTextures,
              transparent: true,
            });
          }

          if (e.name.startsWith("banner")) {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.bannerTexture,
              transparent: true,
            });
          }

          if (e.name === "partners") {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.partnersTexture,
            });
          }

          if (e.name === "partners-hover") {
            this.intersectObjects.push(e);

            e.material = new THREE.MeshBasicMaterial({
              color: 0xf5f5f5,
              transparent: true,
              opacity: 0,
            });

            console.log("hovered");
          }

          if (e.name === "documents") {
            e.material = new THREE.MeshBasicMaterial({
              // color: 0xff0000,
              map: this.documentsTexture,
              transparent: true,
            });
          }

          //? animating objects inside scene

          //! animating the big bottles
          if (e.name === "shishja_1_th") {
            targetsToMove.push(e);
          }

          if (e.name === "real_texture_label_1") {
            targetsToMove.push(e);
          }

          //? 2
          if (e.name === "shishja_2_th") {
            targetsToMove.push(e);
          }

          if (e.name === "real_texture_label_2") {
            targetsToMove.push(e);
          }

          //? 3
          if (e.name === "shishja_3_th") {
            targetsToMove.push(e);
          }

          if (e.name === "real_texture_label_3") {
            targetsToMove.push(e);
          }

          //? 4
          if (e.name === "shishja_4_th") {
            targetsToMove.push(e);
          }

          if (e.name === "real_texture_label_4") {
            targetsToMove.push(e);
          }

          //? other objecvts inside the scene

          if (e.name.startsWith("plloqa")) {
            this.plloqa = e;
            this.plloqa.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("pjata_first")) {
            this.plateFirst = e;
            this.plateFirst.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("pjata_second")) {
            this.plateSecond = e;
            this.plateSecond.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("mbajtsja_1")) {
            this.foodFirst = e;
            this.foodFirst.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("mbajtsja_2")) {
            this.foodSecond = e;
            this.foodSecond.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("mbajtsja_3")) {
            this.foodThird = e;
            this.foodThird.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("mbajtsja_3")) {
            this.foodThird = e;
            this.foodThird.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          //? kiosk
          if (e.name.startsWith("cash")) {
            this.cashRegister = e;
            this.cashRegister.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("ketchup_first")) {
            this.ketchupFirst = e;
            this.ketchupFirst.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }
          if (e.name.startsWith("ketchup_second")) {
            this.ketchupSecond = e;
            this.ketchupSecond.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }
          if (e.name.startsWith("hot_plate_two")) {
            this.hotPlateOne = e;
            this.hotPlateOne.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }

          if (e.name.startsWith("hot_plate_three")) {
            this.hotPlateTwo = e;
            this.hotPlateTwo.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }
          if (e.name.startsWith("kiosk_plloqa")) {
            this.kioskPlloqa = e;
            this.kioskPlloqa.scale.set(0, 0, 0);
            this.intersectObjects.push(e);
          }
        }

        //? objects to click

        if (e.name === "menu-click") {
          this.intersectObjects.push(e);
          e.material = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: 0,
            color: 0xf5f5f5,
          });
        }

        if (e.name === "order") {
          this.intersectObjects.push(e);
          e.material = new THREE.MeshBasicMaterial({
            transparent: true,
            opacity: 0,
            color: 0xf5f5f5,
          });
        }
      });

      targetsToMove.forEach((e) => {
        if (e.parent) e.parent.remove(e);
        if (e.name.startsWith("shishja_1_th")) {
          e.position.set(0, 0, 0);
          this.bottleOne.add(e);
        }
        if (e.name.startsWith("real_texture_label_1")) {
          e.position.set(0.038, 0.1, 0);
          this.bottleOne.add(e);
        }
        // ? 2
        if (e.name.startsWith("shishja_2_th")) {
          e.position.set(0, 0, 0);
          this.bottleTwo.add(e);
        }
        if (e.name.startsWith("real_texture_label_2")) {
          e.position.set(0.034, 0.1, -0.014);
          this.bottleTwo.add(e);
        }
        //? 3
        if (e.name.startsWith("shishja_3_th")) {
          e.position.set(0, 0, 0);
          this.bottleThree.add(e);
        }
        if (e.name.startsWith("real_texture_label_3")) {
          e.position.set(0.038, 0.1, 0);
          this.bottleThree.add(e);
        }
        //? 4
        if (e.name.startsWith("shishja_4_th")) {
          e.position.set(0, 0, 0);
          this.bottleFour.add(e);
        }
        if (e.name.startsWith("real_texture_label_4")) {
          e.position.set(0.035, 0.09, -0.014);
          this.bottleFour.add(e);
        }
      });

      this.scene.add(this.piaggioModel.scene);

      this.bottleOne.position.set(0.692, 0.415, -0.84);
      this.bottleOne.scale.set(0.0, 0.0, 0.0);
      this.bottleOne.rotation.x = 0.6;

      this.bottleTwo.position.set(0.73, 0.415, -0.92);
      this.bottleTwo.scale.set(0.0, 0.0, 0.0);
      this.bottleTwo.rotation.x = 0.6;

      this.bottleThree.position.set(0.65, 0.415, -1.37);
      this.bottleThree.scale.set(0.0, 0.0, 0.0);
      this.bottleThree.rotation.x = 0.6;

      this.bottleFour.position.set(0.68, 0.415, -1.45453);
      this.bottleFour.scale.set(0.0, 0.0, 0.0);
      this.bottleFour.rotation.x = 0.6;
      this.scene.add(
        this.bottleOne,
        this.bottleTwo,
        this.bottleThree,
        this.bottleFour
      );

      this.piaggioModel.scene.rotation.y = -3.5;

      if (this.size.mobileSize) {
        this.controls.target.set(1.07591, -0.3, 0.198141);
      } else {
        this.controls.target.set(1.952, 0.1981, 2.57);
      }

      this.timeline = gsap.timeline();

      this.timeline
        .to(this.piaggioModel.scene.rotation, {
          y: 0,
          duration: 2.5,
          ease: "back.out(1.5)",
          delay: 0.25,
        })

        .to(
          this.camera.position,
          {
            duration: 2.5,
            ease: "back.out(1.5)",
          },
          "<"
        )

        .to(this.plloqa.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.5,
        })
        .to(
          this.cashRegister.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            ease: "back.out(1.5)",
            duration: 0.5,
          },
          "<"
        )
        .to(this.firstSmoke.scale, {
          x: 0.5,
          y: 1,
          ease: "back.out(1.5)",
          duration: 0.2,
        })
        .to(
          this.secondSmoke.scale,
          {
            x: 0.5,
            y: 1,
            ease: "back.out(1.5)",
            duration: 0.2,
          },
          "<"
        )
        .to(this.plateFirst.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.35,
        })
        .to(
          this.ketchupFirst.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            ease: "back.out(1.5)",
            duration: 0.35,
          },
          "<"
        )
        .to(this.plateSecond.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.35,
        })
        .to(
          this.ketchupSecond.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            ease: "back.out(1.5)",
            duration: 0.35,
          },
          "<"
        )
        .to(this.foodFirst.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.35,
        })
        .to(
          this.hotPlateTwo.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            ease: "back.out(1.5)",
            duration: 0.35,
          },
          "<"
        )
        .to(this.foodSecond.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.35,
        })
        .to(
          this.hotPlateOne.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            ease: "back.out(1.5)",
            duration: 0.35,
          },
          "<"
        )

        .to(this.foodThird.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.35,
        })
        .to(
          this.kioskPlloqa.scale,
          {
            x: 1,
            y: 1,
            z: 1,
            ease: "back.out(1.5)",
            duration: 0.35,
          },
          "<"
        )
        .to(this.bottleOne.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.375,
        })
        .to(
          this.bottleOne.rotation,
          {
            x: 0,
            ease: "back.out(1.5)",
            duration: 0.375,
          },
          "<"
        )
        .to(this.bottleTwo.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.375,
        })
        .to(
          this.bottleTwo.rotation,
          {
            x: 0,
            ease: "back.out(1.5)",
            duration: 0.375,
          },
          "<"
        )
        .to(this.bottleThree.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.375,
        })
        .to(
          this.bottleThree.rotation,
          {
            x: 0,
            ease: "back.out(1.5)",
            duration: 0.375,
          },
          "<"
        )
        .to(this.bottleFour.scale, {
          x: 1,
          y: 1,
          z: 1,
          ease: "back.out(1.5)",
          duration: 0.375,
        })
        .to(
          this.bottleFour.rotation,
          {
            x: 0,
            ease: "back.out(1.5)",
            duration: 0.375,
          },
          "<"
        );

      //? moving icons

      //! EVENT LISTENERS

      this.buttonContainer.addEventListener("click", (e) => {
        e.preventDefault();

        if (e.target.classList.contains("menu")) {
          this.controls.enabled = true;

          this.infoContainer.style.display = "none";
          this.closeAllInformation();
          if (this.size.mobileSize) {
            gsap.to(this.controls.target, {
              x: 0.95,
              y: 0.17,
              z: -1,
              duration: 2,
              ease: "back.out(1.05)",
            });

            gsap.to(this.camera.position, {
              x: 2.753241713199576,
              y: 0.187754024994156223,
              z: -1.001518640638451,
              duration: 2,
              ease: "back.out(1.05)",
            });
          } else {
            gsap.to(this.controls.target, {
              x: 0.95,
              y: 0.17,
              z: -1,
              duration: 2,
              ease: "back.out(1.05)",
            });

            gsap.to(this.camera.position, {
              x: 1.88,
              y: 0.26,
              z: -1.0523,
              duration: 2,
              ease: "back.out(1.05)",
            });
          }
        }

        if (e.target.classList.contains("reserve")) {
          this.controls.enabled = false;
          this.infoContainerOpen = true;

          this.closeAllInformation();

          document.querySelector(".form").style.display = "flex";

          this.title.innerHTML = "Reserve your spot!";
          gsap.to(this.controls.target, {
            x: 4.383,
            y: 0.06,
            z: 3.646,
            duration: 1,
            ease: "power1.out",
          });
          if (this.size.mobileSize) {
            gsap.to(this.camera.position, {
              x: 4.255,
              y: 0.178,
              z: 0.5565,
              duration: 1,
              ease: "power1.out",
              onComplete: () => {
                this.infoContainer.style.display = "flex";
              },
            });
          } else {
            gsap.to(this.camera.position, {
              x: 4.255,
              y: 0.178,
              z: 0.0565,
              duration: 1,
              ease: "power1.out",
              onComplete: () => {
                this.infoContainer.style.display = "flex";
              },
            });
          }
        }

        if (e.target.classList.contains("family")) {
          this.controls.enabled = false;
          this.infoContainerOpen = true;

          this.closeAllInformation();
          this.infoContainer.style.display = "none";

          document.querySelector(".crepe-about").style.display = "flex";
          this.title.innerHTML = "Qui est la Crêpes family?";
          this.infoContainer.style.display = "flex";
        }

        if (e.target.classList.contains("pop")) {
          this.closeAllInformation();
          this.infoContainer.style.display = "none";

          gsap.to(this.controls.target, {
            x: 0.89,
            y: -0.13,
            z: 0.24,
            duration: 1,
            ease: "power1.out",
          });

          if (this.size.mobileSize) {
            gsap.to(this.camera.position, {
              x: 2.789,
              y: -0.129,
              z: 0.297,
              duration: 1.5,
              ease: "power1.out",
            });
          } else {
            gsap.to(this.camera.position, {
              x: 2.151,
              y: -0.095,
              z: 0.2833714,
              duration: 1.5,
              ease: "power1.out",
            });
          }

          // -2.899204500488279 0.1981000000000003 6.432235257202127
        }

        if (e.target.classList.contains("documents-btn")) {
          this.controls.enabled = false;
          this.infoContainerOpen = true;

          this.closeAllInformation();
          this.infoContainer.style.display = "none";
          this.title.innerHTML = "Documents & Info";
          document.querySelector(".documents-con").style.display = "flex";

          gsap.to(this.controls.target, {
            x: -0.909197,
            y: 0.094772,
            z: -0.058808,
            duration: 1.75,
            ease: "back.out(1.05)",
            onComplete: () => {
              this.infoContainer.style.display = "flex";
            },
          });

          if (this.size.mobileSize) {
            gsap.to(this.camera.position, {
              x: -6.619,
              y: 0.84,
              z: -3.762,
              duration: 1.5,
              ease: "power1.out",
            });
          } else {
            gsap.to(this.camera.position, {
              x: -6.11,
              y: 1.088,
              z: -3.26,
              duration: 1.5,
              ease: "power1.out",
            });
          }
        }
      });

      this.closeInfoButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.infoContainerOpen = false;

        this.infoContainer.style.display = "none";
        this.controls.enabled = true;
        if (this.size.mobileSize) {
          gsap.to(this.controls.target, {
            x: 1.075,
            y: -0.3,
            z: 0.198141,
            duration: 1,
            ease: "power1.out",
          });

          gsap.to(this.camera.position, {
            x: 6.501,
            y: 0.5,
            z: 0.111,

            duration: 1,
            ease: "power1.out",
          });
        } else {
          gsap.to(this.controls.target, {
            x: 1.95,
            y: 0.1981,
            z: 2.57,

            duration: 1,
            ease: "power1.out",
          });
          gsap.to(this.camera.position, {
            x: 6.482,
            y: 0.5,
            z: -3.754,

            duration: 1,
            ease: "power1.out",
          });
        }
      });

      this.debugActive();
    });
  }

  closeAllInformation() {
    document.querySelector(".form").style.display = "none";
    document.querySelector(".crepe-about").style.display = "none";
    document.querySelector(".documents-con").style.display = "none";
  }

  createMovingIcons(
    sFirst,
    sSecond,
    pX,
    pY,
    pZ,
    mY,
    duration,
    delay,
    isWiggle,
    material,
    music
  ) {
    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(sFirst, sSecond),
      material
    );

    this.scene.add(mesh);

    mesh.position.set(pX, pY, pZ);
    mesh.rotation.y = 1.5;

    if (this.experience.debug.active) {
      this.meshFolder = this.experience.debug.gui.addFolder("mesh-debug");
      this.meshFolder.add(mesh.position, "x").min(-10).max(10).step(0.01);
      this.meshFolder.add(mesh.position, "y").min(-10).max(10).step(0.01);

      this.meshFolder.add(mesh.position, "z").min(-10).max(10).step(0.01);
    }

    const tl = gsap.timeline({ repeat: 2, repeatDelay: 1 });

    if (isWiggle) {
      mesh.rotateZ = -0.5;
      tl.to(mesh.rotation, {
        repeat: -1,
        z: 0.5,
        duration: 0.5,
        delay: delay,
        ease: CustomEase.create(
          "custom",
          "M0,0 C0.085,0.61 0.265,1 0.5,1 0.8,1 0.896,0.57 1,0 "
        ),
      });
    }

    // tl.to(mesh.position, {
    //   repeat: -1,
    //   y: mY,
    //   duration: duration,
    //   delay: delay,
    //   ease: "power1.out",
    // })
    //   .to(
    //     mesh.scale,
    //     {
    //       repeat: -1,
    //       x: 0,
    //       y: 0,
    //       z: 0,
    //       duration: duration,
    //       ease: "power1.out",
    //     },
    //     "<"
    //   )
    //   .to(
    //     mesh.material,
    //     {
    //       opacity: 1,
    //       duration: 1,

    //       ease: "power2.out",
    //     },
    //     "<"
    //   );

    if (music) {
      // this.timeLines.push(tl);
    }
  }

  setUpLights() {
    //? lighting
    this.ambientLight = new THREE.AmbientLight(0xf5f5f5, 3);
    // this.scene.add(this.ambientLight);

    this.directionalLight = new THREE.DirectionalLight(0xffffff, 2.5);
    this.directionalLight.castShadow = true;
    this.directionalLight.shadow.mapSize.width = 1024;
    this.directionalLight.shadow.mapSize.height = 1024;

    this.directionalLight.shadow.camera.near = 4;
    this.directionalLight.shadow.camera.far = 20;
    this.directionalLight.position.set(8.5, 6.8, -6.7);

    this.directionalLightHelper = new THREE.CameraHelper(
      this.directionalLight.shadow.camera
    );

    this.scene.add(this.directionalLight);
  }

  setUpLoadingScreen(video) {
    this.monitor = document.createElement("video");

    this.monitor.muted = true;
    this.monitor.controls = true;
    this.monitor.playsInline = true;
    // this.monitor.autoplay = true;
    this.monitor.loop = true;
    this.monitor.currentTime = 1;
    this.monitor.allowsFullscreen = false;
    this.monitor.preload = "metadata";

    this.monitor.controlsList = "nofullscreen";
    this.monitor.src = video;
    document.querySelector("body").append(this.monitor);

    this.monitor.style.position = "fixed";
    this.monitor.style.top = 0;
    this.monitor.style.right = 0;
    this.monitor.style.zIndex = 0;
    this.monitor.style.maxWidth = "5px";
    this.monitor.style.maxHeight = "5px";
    this.monitor.style.opacity = 0;
    this.monitor.style.pointerEvents = "none";

    this.monitorTexture = new THREE.VideoTexture(this.monitor);
    this.monitorTexture.colorSpace = THREE.SRGBColorSpace;

    this.monitorTexture.flipY = false;

    return new THREE.MeshBasicMaterial({
      map: this.monitorTexture,
    });
  }

  debugActive() {
    if (this.experience.debug.active) {
      this.worldFolder = this.experience.debug.gui.addFolder("world-Debug");

      this.worldFolder
        .add(this.firstSmoke.position, "x")
        .min(-10)
        .max(10)
        .step(0.01);

      this.worldFolder
        .add(this.firstSmoke.position, "y")
        .min(-10)
        .max(10)
        .step(0.01);

      this.worldFolder
        .add(this.firstSmoke.position, "z")
        .min(-10)
        .max(10)
        .step(0.01);

      this.worldFolder
        .add(this.smokeMaterial, "opacity")
        .min(0)
        .max(1)
        .step(0.01);
    }
  }

  update() {
    if (this.smokeMaterial) {
      this.smokeMaterial.uniforms.uTime.value = this.time.elapsed;
    }
    if (this.rayCaster) {
      this.rayCaster.setFromCamera(this.pointer, this.camera);
      this.intersects = this.rayCaster.intersectObjects(this.intersectObjects);

      if (this.intersects.length) {
        this.currentIntersect = this.intersects[0];
        if (!this.infoContainerOpen) {
          if (this.currentIntersect.object.name === "partners-hover") {
            document.body.style.cursor = "pointer";

            gsap.to(this.currentIntersect.object.material, {
              opacity: 0.75,
              ease: "power1.out",
              duration: 0.25,
            });

            if (this.clicked) {
              this.closeAllInformation();
              this.infoContainer.style.display = "none";
              gsap.to(this.controls.target, {
                x: 0.89,
                y: -0.13,
                z: 0.24,
                duration: 1,
                ease: "power1.out",
              });

              if (this.size.mobileSize) {
                gsap.to(this.camera.position, {
                  x: 2.789,
                  y: -0.129,
                  z: 0.297,
                  duration: 1.5,
                  ease: "power1.out",
                });
              } else {
                gsap.to(this.camera.position, {
                  x: 2.151,
                  y: -0.095,
                  z: 0.2833714,
                  duration: 1.5,
                  ease: "power1.out",
                });
              }
            }
          } else if (this.currentIntersect.object.name === "menu-click") {
            document.body.style.cursor = "pointer";
            gsap.to(this.currentIntersect.object.material, {
              opacity: 0.75,

              ease: "power1.out",
              duration: 0.25,
            });
            if (this.clicked) {
              this.controls.enabled = true;
              this.infoContainer.style.display = "none";
              this.closeAllInformation();
              if (this.size.mobileSize) {
                gsap.to(this.controls.target, {
                  x: 0.95,
                  y: 0.17,
                  z: -1,
                  duration: 2,
                  ease: "back.out(1.05)",
                });

                gsap.to(this.camera.position, {
                  x: 2.753241713199576,
                  y: 0.187754024994156223,
                  z: -1.001518640638451,
                  duration: 2,
                  ease: "back.out(1.05)",
                });
              } else {
                gsap.to(this.controls.target, {
                  x: 0.95,
                  y: 0.17,
                  z: -1,
                  duration: 2,
                  ease: "back.out(1.05)",
                });

                gsap.to(this.camera.position, {
                  x: 1.88,
                  y: 0.26,
                  z: -1.0523,
                  duration: 2,
                  ease: "back.out(1.05)",
                });
              }
            }
          } else if (this.currentIntersect.object.name === "order") {
            document.body.style.cursor = "pointer";

            gsap.to(this.currentIntersect.object.material, {
              opacity: 0.75,

              ease: "power1.out",
              duration: 0.25,
            });
            if (this.clicked) {
              this.controls.enabled = false;

              this.closeAllInformation();
              document.querySelector(".form").style.display = "flex";

              this.title.innerHTML = "Demande envoyée";
              gsap.to(this.controls.target, {
                x: 4.383,
                y: 0.06,
                z: 3.646,
                duration: 1,
                ease: "power1.out",
              });
              if (this.size.mobileSize) {
                gsap.to(this.camera.position, {
                  x: 4.255,
                  y: 0.178,
                  z: 0.5565,
                  duration: 1,
                  ease: "power1.out",
                  onComplete: () => {
                    this.infoContainer.style.display = "flex";
                  },
                });
              } else {
                gsap.to(this.camera.position, {
                  x: 4.255,
                  y: 0.178,
                  z: 0.0565,
                  duration: 1,
                  ease: "power1.out",
                  onComplete: () => {
                    this.infoContainer.style.display = "flex";
                  },
                });
              }
            }
          } else {
            gsap.to(this.currentIntersect.object.scale, {
              y: 1.2,
              x: 1.2,
              z: 1.2,
              duration: 0.25,
            });
          }
        }

        //? drawer
      } else if (!this.intersects.length) {
        this.currentIntersect = null;

        document.body.style.cursor = "auto";
        if (this.intersectObjects) {
          this.intersectObjects.forEach((e) => {
            if (e.isMesh) {
              if (e.material.opacity > 0.74) {
                gsap.to(e.material, {
                  opacity: 0,
                  duration: 0.25,
                  ease: "power1.inOut",
                });
              }
              if (e.scale.x > 1) {
                gsap.to(e.scale, {
                  x: 1,
                  y: 1,
                  z: 1,
                  ease: "back.out(1.5)",
                  duration: 0.25,
                });
              }
            }
          });
        }
      }
    }

    this.clicked = false;
  }
}
